export enum ScreenType {
  START = "start",
  EDITOR = "editor",
  END = "end",
}

export enum TestType {
  COMP_SCI = "comp_sci",
}

export interface LogEntry {
  message: string;
  sus: boolean;
  timestamp: string;
}

export interface Question {
  questionNumber: number;
  questionText: string;
  maximumMarks: number;
  markScheme: string[];
  sampleAnswer: string;
}

export interface MarkResponse {
  [key: string]: {
    marks_awarded: number;
    feedback: string;
  };
}

export const questions: Question[] = [
  {
    questionNumber: 1,
    questionText: `Discuss the role of p53 in the regulation of the cell cycle and its implications in cancer development.`,
    maximumMarks: 6,
    markScheme: [
      `p53 is a tumor suppressor protein (1).`,
      `It regulates the cell cycle by halting progression at the G1/S checkpoint if DNA damage is detected (1).`,
      `p53 activates DNA repair mechanisms (1).`,
      `If damage is irreparable, p53 induces apoptosis (1).`,
      `Loss or mutation of p53 is associated with uncontrolled cell division and tumor formation (1).`,
      `Mutations in TP53 are common in many cancers (1).`,
    ],
    sampleAnswer: `p53 is a protein that helps control the cell cycle. It stops cells from dividing when something is wrong. If there is DNA damage, p53 can stop the cycle and try to repair the cell. If it can’t fix it, it causes the cell to die. Problems with p53 can cause cancer because the cells keep dividing.`,
  },
  {
    questionNumber: 2,
    questionText: `Explain the mechanism of action of insulin at the cellular level and how insulin resistance contributes to type 2 diabetes.`,
    maximumMarks: 6,
    markScheme: [
      `Insulin binds to insulin receptors on target cells (1).`,
      `This activates a signaling cascade involving IRS, PI3K, and Akt (1).`,
      `GLUT4 vesicles translocate to the plasma membrane to facilitate glucose uptake (1).`,
      `In insulin resistance, this signaling pathway is impaired (1).`,
      `As a result, glucose uptake is reduced despite high insulin levels (1).`,
      `This leads to hyperglycemia and the clinical features of type 2 diabetes (1).`,
    ],
    sampleAnswer: `Insulin helps cells take in glucose from the blood. It binds to receptors on cells which causes glucose channels to open. In type 2 diabetes, the body doesn’t respond to insulin properly, so glucose stays in the blood. This is called insulin resistance.`,
  },
];
